import { render, staticRenderFns } from "./AssignAffinitySlider.vue?vue&type=template&id=18a0b494"
import script from "./AssignAffinitySlider.vue?vue&type=script&lang=js"
export * from "./AssignAffinitySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports